import { headerStyles } from "@waytek/Overrides/Widgets/OrderHistory/OrderHistoryHeader";
import { fontFamily } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.container = {
    ...headerStyles.container,
    css: css`
        padding-top: 24px;
        padding-bottom: 20px;
    `,
};

headerStyles.invoiceCountGridItem = {
    ...headerStyles.invoiceCountGridItem,
    style: { fontWeight: 500 },
    css: css`
        font-family: ${fontFamily};
        font-size: 18px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
    `,
};

headerStyles.toggleFilterButton = {
    ...headerStyles.toggleFilterButton,
    buttonType: "outline",
    css: css`
        ${headerStyles.toggleFilterButton?.css}

        &&&:hover {
            &::after {
                content: none;
            }
        }
    `,
};
